import Wiesner from "../assets/wiesner.png";
import WiesnerFade from "../assets/wienser_fade.png";
import Lines from "../assets/lines_2.svg";
import "./infoBanner.component.css";
 
/**
 * Info Banner component
 * @param className Further class names
 * @param key Further keys
 * @return Info Banner component
 */
function InfoBannerComponent(
    props: Readonly<{
        isEnglish: boolean,
        setIsEnglish: (newValue: boolean) => void,
        className?: string,
        [key: string]: any
    }>
) {
    const { className, isEnglish, setIsEnglish, ...overflowProps } = props;

    var ReactRotatingText = require('react-rotating-text');

    return (
        <div className={`info-banner-component ${className ?? ""}`} {...overflowProps}>
            <div className="image-container">
                <img src={Lines} alt="lines" />
            </div>

            <div className="info-container">
                <div className="wiesner-container">
                    <img src={window.innerWidth < 980 ? WiesnerFade : Wiesner} alt="wiesner" />
                </div>
                
                <div className="info-to-front flex column gap">
                    <h2>
                        <ReactRotatingText emptyPause={500} pause={3000} items={['Hallo!', 'Moin!', 'Hoi!', "Bonjour!", "Ciao!", "Hej!", "Merhaba!", "Salut!", "Hello!"]} />
                    </h2>
                    {isEnglish ?
                        <h6>Since 2009, I have held a professorship in Business Information and Communication Systems at the <a className="green" href="https://www.hwr-berlin.de/">Berlin School of Economics and Law</a>. Here you will find information about my CV, publications, projects, and more.</h6>
                    :
                        <h6>Seit 2009 habe ich eine Professur für Betriebliche Informations und Kommunikationssysteme an der <a className="green" href="https://www.hwr-berlin.de/">Hochschule für Wirtschaft und Recht Berlin</a>. Informationen zu meinem Lebenslauf, meinen Publikationen, Projekten und mehr finden Sie hier.</h6>
                    }
                </div>
            </div>
        </div>
    )
}

export default InfoBannerComponent;